import "./ReportPage.less";

import React from "react";
import { Redirect, RouteComponentProps } from "react-router";

import { IBaseProps, IReportProps } from "lib/data/interfaces";
import { Report } from "lib/enumerations";

import { SectionReport, SectionTreeReport } from "components/reports";


interface IReportPageProps extends IBaseProps, RouteComponentProps<any> {
	id: number;
}

interface IReportPageState {

}

interface IReport {
	key: Report;
	component: React.ElementType<IReportProps>;
}

export class ReportPage extends React.Component<IReportPageProps, IReportPageState> {

	public static readonly BasePath: string = "/report";

	private reports: IReport[] = [
		{
			key: Report.SectionReport,
			component: SectionReport
		},
		{
			key: Report.SectionTreeReport,
			component: SectionTreeReport
		}
	];

	public render() {

		// Parse Report ID From Url
		let reportId = this.props.match.params.id;

		// Check Report ID
		if (reportId === undefined || reportId === null || Number.isNaN(Number.parseInt(reportId, 10))) {

			// Clear Report ID
			reportId = undefined;
		}
		else {

			// Set Report ID
			reportId = Number.parseInt(reportId, 10);
		}

		// Check Other States
		if (reportId === undefined || this.reports.find((report) => report.key === reportId) === undefined) {

			// Redirect To Home
			return <Redirect to="/" push={false} />;
		}

		// Get Report Component
		const ReportComponent = this.reports.find((report) => report.key === reportId)!.component;

		// Render Report
		return <ReportComponent queryString={this.props.location.search} />;
	}
}
